module.exports = "/_next/static/images/GOER-Mirnawati-514dad597812ed2d35267236921e6d43.svg";